import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Sparkles } from "lucide-react";

const AI_SEARCH_PHRASES = [
  "Analisando mais de 2.000 espaços...",
  "Cruzando perfil da empresa com dados locais...",
  "Calculando score de compatibilidade...",
  "Identificando espaços alinhados ao perfil...",
  "Verificando amenidades e infraestrutura...",
  "Aplicando inteligência de localização...",
  "Ranqueando por compatibilidade e custo-benefício...",
];

export function AISearchLoader() {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setFadeIn(false);
      setTimeout(() => {
        setPhraseIndex((i) => (i + 1) % AI_SEARCH_PHRASES.length);
        setFadeIn(true);
      }, 350);
    }, 2400);
    return () => clearInterval(timer);
  }, []);

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center select-none"
      style={{ background: "rgba(26,24,20,0.6)", backdropFilter: "blur(4px)" }}
    >
      <div
        className="flex flex-col items-center text-center mx-6"
        style={{
          background: "#FFD900",
          borderRadius: 24,
          padding: "40px 36px 36px",
          maxWidth: 360,
          width: "100%",
          boxShadow:
            "0 32px 64px rgba(0,0,0,0.28), 0 0 0 1px rgba(255,255,255,0.12)",
        }}
      >
        <div className="relative mb-7" style={{ width: 88, height: 88 }}>
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(26,24,20,0.08) 0%, transparent 70%)",
            }}
          />

          <div
            className="absolute inset-0 rounded-full border"
            style={{
              borderColor: "rgba(26,24,20,0.18)",
              animation: "aiOrbitOuter 3.2s linear infinite",
            }}
          >
            <div
              className="absolute rounded-full"
              style={{
                width: 9,
                height: 9,
                background: "#1A1814",
                top: -4.5,
                left: "50%",
                marginLeft: -4.5,
                boxShadow: "0 0 12px 2px rgba(26,24,20,0.35)",
              }}
            />
          </div>

          <div
            className="absolute rounded-full border"
            style={{
              inset: 16,
              borderColor: "rgba(26,24,20,0.12)",
              animation: "aiOrbitInner 2s linear infinite reverse",
            }}
          >
            <div
              className="absolute rounded-full"
              style={{
                width: 6,
                height: 6,
                background: "rgba(26,24,20,0.55)",
                bottom: -3,
                left: "50%",
                marginLeft: -3,
              }}
            />
          </div>

          <div className="absolute inset-0 flex items-center justify-center">
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: "50%",
                background: "rgba(26,24,20,0.07)",
                animation: "aiPulseCore 1.8s ease-in-out infinite",
              }}
            />
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Sparkles
              className="w-4 h-4"
              style={{ color: "#1A1814", position: "relative", zIndex: 1 }}
            />
          </div>
        </div>

        <h2
          className="font-bold leading-tight mb-1"
          style={{ color: "#1A1814", fontSize: 22 }}
        >
          Buscando espaços
        </h2>

        <div
          style={{ minHeight: 40 }}
          className="flex items-center justify-center mt-2"
        >
          <p
            className="text-sm leading-snug"
            style={{
              color: "rgba(26,24,20,0.62)",
              opacity: fadeIn ? 1 : 0,
              transform: fadeIn ? "translateY(0)" : "translateY(-4px)",
              transition: "opacity 0.35s ease, transform 0.35s ease",
            }}
          >
            {AI_SEARCH_PHRASES[phraseIndex]}
          </p>
        </div>
      </div>

      <style>{`
        @keyframes aiDotPulse {
          0%, 80%, 100% { opacity: 0.25; transform: scale(1); }
          40% { opacity: 1; transform: scale(1.4); background: #1A1814; }
        }
      `}</style>
    </div>,
    document.body,
  );
}
